import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Config from '../Config';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { useAuthHandling } from '../useAuthhandling';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

function SubcategoryView() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const location = useLocation();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    let { id } = useParams();
    const [service, setService] = useState([]);
    const [toggle, setToggle] = useState(false);

    const getinfo = async (e) => {
        if (location.state.level === 1) {
            const res = await fetch(
                `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
                {
                    method: "POST",

                    body: JSON.stringify({
                        levelOneCategory: id,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                        Authorization: `Bearer ${Cookies.get("a_token")}`,
                    },
                }
            );

            if (res.status === 200) {
                const data = await res.json();

                setService(data.data);
            }
            else if (res.status === 401) {
                handleUnauthorized();
                getinfo();
            }
            else {
                alert("error");

            }
        } else if (location.state.level === 2) {
            const res = await fetch(
                `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
                {
                    method: "POST",

                    body: JSON.stringify({
                        levelOneCategory: location.state.levelsdata.levelOneId,
                        levelTwoCategory: id,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                        Authorization: `Bearer ${Cookies.get("a_token")}`,
                    },
                }
            );

            if (res.status === 200) {
                const data = await res.json();
                setService(data.data);
            }
            else if (res.status === 401) {
                handleUnauthorized();
                getinfo();
            }
            else {
                alert("error");

            }
        } else if (location.state.level === 3) {
            const res = await fetch(
                `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
                {
                    method: "POST",

                    body: JSON.stringify({
                        levelOneCategory: location.state.levelsdata.levelOneId,
                        levelTwoCategory: location.state.levelsdata.levelTwoId,
                        levelThreeCategory: id,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                        Authorization: `Bearer ${Cookies.get("a_token")}`,
                    },
                }
            );

            if (res.status === 200) {
                const data = await res.json();
                setService(data.data);
            }
            else if (res.status === 401) {
                handleUnauthorized();
                getinfo();
            }
            else {
                alert("error");


            }
        } else if (location.state.level === 4) {
            const res = await fetch(
                `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
                {
                    method: "POST",

                    body: JSON.stringify({
                        levelOneCategory: location.state.levelsdata.levelOneId,
                        levelTwoCategory: location.state.levelsdata.levelTwoId,
                        levelThreeCategory: location.state.levelsdata.levelThreeId,
                        levelFourCategory: id,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                        Authorization: `Bearer ${Cookies.get("a_token")}`,
                    },
                }
            );

            if (res.status === 200) {
                const data = await res.json();
                setService(data.data);
            }
            else if (res.status === 401) {
                handleUnauthorized();
                getinfo();
            }
            else {
                alert("error");


            }
        }
    };

    useEffect(() => {
        getinfo();
    }, []);
    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        {/* <div className='view_page_top'>
                            <Link to="/servicelist">Subcategory list</Link>
                            <Link to={"/editservice/" + id} >Edit</Link>
                        </div> */}
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Category View page</h4>

                                        <div className='row view_div_row'>
                                            {location.state.level !== 1 ?
                                                <div className='col-12 subcate_view'>
                                                    <div className='view_portion_cate'>
                                                        <h6 className='view_portion_cate_h6 '>Parent Categories</h6>
                                                        <div className='row'>
                                                        <div className='col-6 '>
                                                            <div className='view_portion'>
                                                                <div className='view_portion_h6'>
                                                                    <h6>Level one Category</h6>
                                                                </div>
                                                                <div className='view_portion_p'>
                                                                    {location?.state?.level === 2?
                                                                    <p> {service[0]?.categoryName}</p>
                                                                    :location?.state?.level === 3 || location?.state?.level === 4?
                                                                    <p> {service[0]?.levelOneName}</p>
                                                                    :""
                                                                }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {location?.state?.level === 3 || location?.state?.level === 4?
                                                        <div className='col-6 '>
                                                        <div className='view_portion'>
                                                            <div className='view_portion_h6'>
                                                                <h6>Level Two Category</h6>
                                                            </div>
                                                            <div className='view_portion_p'>
                                                                
                                                                <p> {service[0]?.levelTwoName}</p>
                                                               
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :""}

{ location?.state?.level === 4?
                                                        <div className='col-6 '>
                                                        <div className='view_portion'>
                                                            <div className='view_portion_h6'>
                                                                <h6>Level Three Category</h6>
                                                            </div>
                                                            <div className='view_portion_p'>
                                                                
                                                                <p> {service[0]?.levelThreeName}</p>
                                                               
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :""}
                                                    </div>
                                                    </div>
                                                </div>
                                                : ""}
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Category Name </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    {location.state.level != 1 ?
                                                        <p> {service[0]?.categoryInfo[0]?.categoryName}</p>
                                                        :
                                                        <p> {service?.categoryName}</p>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Slug </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    {location.state.level != 1 ?
                                                        <p> {service[0]?.categoryInfo[0]?.categorySlug}</p>
                                                        :
                                                        <p>  {service?.categorySlug}</p>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Description</h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                    {location.state.level != 1 ?
                                                        <p> {service[0]?.categoryInfo[0]?.categoryDescription}</p>
                                                        :
                                                        <p>  {service?.categoryDescription}</p>
                                                    }
                                                    </div>

                                                </div>
                                            </div>

                                            {location.state.level != 1 && service[0]?.categoryInfo[0]?.categoryImg ?
                                                <div className='col-12 '>
                                                    <div className='view_portion'>
                                                        <div className='view_portion_h6'>
                                                            <h6> Image </h6>
                                                        </div>
                                                        <div className='view_portion_p'>
                                                            <img src={service[0]?.categoryInfo[0]?.categoryImg} style={{ width: "100px", height: "100px", marginTop: "10px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                :location.state.level === 1 && service.categoryImg?
                                                    <div className='col-12 '>
                                                        <div className='view_portion'>
                                                            <div className='view_portion_h6'>
                                                                <h6> Image </h6>
                                                            </div>
                                                            <div className='view_portion_p'>
                                                                <img src={service?.categoryImg} style={{ width: "100px", height: "100px", marginTop: "10px" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                :""
                                            }

                                            {location.state.level != 1 && location.state.level != 4 ?
                                             <div className='col-12 '>
                                             <div className='view_portion'>
                                                 <div className='view_portion_h6 view_portion_h6_togg' onClick={(e)=>setToggle(!toggle)}>
                                                     <h6> Sub Categories </h6>
                                                     {toggle?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                                }
                                                 </div>
                                                 {toggle?
                                                 <div className='view_portion_p'>
                                                 {location.state.level != 1 && location.state.level != 4 && service[0]?.categoryInfo[0]?.subcategories.length>0?
                                                    <ul>
                                                        {service[0]?.categoryInfo[0]?.subcategories?.map((sub,i)=>{
                                                            return(
                                                                <li>{sub.categoryName}</li>
                                                            )
                                                        })}
                                                       
                                                    </ul>
                                                    :""
                                                 }
                                                 </div>
                                                 :""}



                                             </div>
                                         </div>
                                         :""
}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubcategoryView
